// extracted by mini-css-extract-plugin
module.exports = {"SmallBookingButton":"booking-button-small_SmallBookingButton__1BgRm","selected":"booking-button-small_selected__TSQQ_"};